import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';
import { getAccountClientGroups, getAcgUsers, getUsers } from 'Selectors/common';

const getIncludeDeleted = (_state: AdminState | ClientState, _userId: string, includeDeleted: boolean, _acgId: string) => includeDeleted;
const getAcgId = (_state: AdminState | ClientState, _userId: string, _includeDeleted: boolean, acgId: string) => acgId;

export const getAcgUsersArray = createSelector([ getAcgUsers, getIncludeDeleted ], (acgUsers, includeDeleted) => {
    return Object.values(acgUsers)
        .filter(acg => {
            if (includeDeleted) {
                return acg;
            } else {
                return !acg.IsDeleted;
            }
        });
});

export const getAcgUsersbyACGID = createSelector(
    [ getAcgUsersArray, getAccountClientGroups, getUsers, getAcgId ],
    (acgUsersArray, accountClientGroups, users, acgID) => {
        return acgUsersArray
            .filter(user => acgID === user.ACGId)
            .map(user => ({
                acgUser: user,
                user: users[user.UserId] || {},
                acg: accountClientGroups[user.ACGId]
            }));
    }
);